export default __webpack_public_path__ + "static/media/airlockz-blk-banner-1.f63d858d.jpg";